<div class="w-full rounded-lg shadow-lg bg-white p-2 flex flex-col transition-all duration-300 ease-in-out"
  [ngClass]="{'gap-2': isOpen, 'gap-0': !isOpen}">
  <div class="z-10">
    <vw-calendar-hierarchy-card-item [cultivation]="hierarchy.cultivations[0]"
      [name]="hierarchy.cultivations.length > 1 ? hierarchy.name.toString() : hierarchy.cultivations[0].name.toString()"
      [type]="hierarchy.cultivations.length > 1 ? 'hierarchy' : 'cultivation'" [periods]="hierarchy.periods"
      [isOpen]="isOpen" (clickItem)="onParentClick()" [showSeed]="showSeed"
      [showHarvest]="showHarvest"></vw-calendar-hierarchy-card-item>
  </div>
  @if (hierarchy.cultivations.length > 1) {
  <div #expandContent class="transition-all duration-300 ease-in-out flex flex-col gap-2 w-full z-0"
    [style.height]="isOpen ? expandContent.scrollHeight + 'px' : '0'" [style.opacity]="isOpen ? '1' : '0'">
    @for (cultivation of hierarchy.cultivations; track cultivation) {
    <vw-calendar-hierarchy-card-item [cultivation]="cultivation" [type]="'cultivation'" [periods]="cultivation.periods"
      [isOpen]="isOpen" (clickItem)="onChildClick(cultivation)" [showSeed]="showSeed"
      [showHarvest]="showHarvest"></vw-calendar-hierarchy-card-item>
    }
  </div>
  }
</div>